import { parseIsoToDate } from './dateUtils';

/**
 * Parse a string to a positive integer.
 * Removes whitespace, rounds to nearest integer, and returns absolute value.
 */
export const parsePositiveInteger = (value: string): number | null => {
  const numberValue = parseFloat(value.replace(/\s+/, ''));
  const returnValue = isNaN(numberValue) ? null : Math.abs(Math.round(numberValue));
  return returnValue;
};

/**
 * Parse an ISO string to a Date object.
 * @param dateTime - ISO string
 * @param hasTime - Whether the time component is significant (for timezone handling)
 * @returns Date object or null
 */
export const parseDateTimeToDate = (dateTime: string | null | undefined, hasTime: boolean = true): Date | null => {
  return parseIsoToDate(dateTime);
};

/**
 * Validate an email address format.
 */
export const isValidEmail = (value: string): boolean => {
  const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

  return value && EMAIL_REGEXP.test(value);
};
